import dayjs from 'dayjs';

export interface IRefAdr {
  id?: number;
  codeUN?: string | null;
  description?: string | null;
  stickerClass1?: string | null;
  stickerClass2?: string | null;
  stickerClass3?: string | null;
  stickerClass4?: string | null;
  packingGroup?: string | null;
  transportCategory?: number | null;
  language?: string | null;
  classification?: string | null;
  tunnelRestriction?: string | null;
  specialProvisions?: string | null;
  startValidity?: dayjs.Dayjs | null;
  endValidity?: dayjs.Dayjs | null;
  active?: boolean | null;
}

export class RefAdr implements IRefAdr {
  constructor(
    public id?: number,
    public codeUN?: string | null,
    public description?: string | null,
    public stickerClass1?: string | null,
    public stickerClass2?: string | null,
    public stickerClass3?: string | null,
    public stickerClass4?: string | null,
    public packingGroup?: string | null,
    public transportCategory?: number | null,
    public language?: string | null,
    public classification?: string | null,
    public tunnelRestriction?: string | null,
    public specialProvisions?: string | null,
    public startValidity?: dayjs.Dayjs | null,
    public endValidity?: dayjs.Dayjs | null,
    public active?: boolean | null
  ) {
    this.active = this.active ?? false;
  }
}

export function getRefAdrIdentifier(refAdr: IRefAdr): number | undefined {
  return refAdr.id;
}
